angular.module 'app'
.config ($stateProvider) ->
  $stateProvider
    .state 'app.cemMaking',
      url: '/cem-making'
      templateUrl: 'apps/cem/cem-making'
      controller: 'CemMakingCtrl'


